/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FlagsInputs */

const de__field_flags = /** @type {(inputs: _Field_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampagenselektion`)
};

/**

* @param {_Field_FlagsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_flags = /** @type {((inputs?: _Field_FlagsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FlagsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_flags(inputs)
});